import { Box, Link } from '@mui/material';
import { ReactNode } from 'react';

import { FileDownload } from '../types';
import { useSxStyles } from '../useStyles';

export type LDFT_RenderCell = { renderCell: ReactNode };
export type ReadCellData = string | number | FileDownload | LDFT_RenderCell;

export const ReadTable = ({ readData }: { readData: ReadCellData[][] }) => {
  const sxStyles = useSxStyles();
  const renderField = (cellData: ReadCellData, index: number) => {
    if (typeof cellData === 'string') {
      return cellData;
    } else if (typeof cellData === 'number') {
      return cellData;
    } else if (!cellData) {
      return '';
    } else if (
      !!(cellData as FileDownload).hrefLink &&
      !!(cellData as FileDownload).name
    ) {
      const fileCellData = cellData as FileDownload;

      return (
        <Link
          sx={{ color: 'black' }}
          href={fileCellData.hrefLink}
          target="_blank"
          rel="noreferrer"
        >
          {fileCellData.name}
        </Link>
      );
    } else if (!!(cellData as LDFT_RenderCell).renderCell) {
      return (cellData as LDFT_RenderCell).renderCell;
    }
  };
  return (
    <Box component={'tbody'}>
      {readData.map((row, index) => {
        return (
          <Box component={'tr'} key={index}>
            {row.map((column, index) => (
              <Box component={'td'} key={index} sx={sxStyles.td}>
                {renderField(column, index)}
              </Box>
            ))}
          </Box>
        );
      })}
    </Box>
  );
};
